export default __webpack_public_path__ + "static/media/enterpriseIcon.e3c6d9c4.png";